var render = function render(_c,_vm){return _c('td',[_c('button',[_c('Icon',{staticClass:"icon",attrs:{"icon":_vm.props.active ? 'pause' :'play'}}),_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.props.value || '-'))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }